export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    user: null,
    userProfileUri: null
  },
  mutations: {
    updateIsAuthenticated(state, value) {
      state.isAuthenticated = value;
    },
    updateUser(state, value) {
      state.user = value;
      if (!state.user) {
        state.isAuthenticated = false;
      }
      else {
        state.user.enableSMS = state.user.idTokenClaims.phone && state.user.idTokenClaims.phone.length > 0;
      }
    },
  },
  actions: {
    async checklogin({ commit, dispatch }) {
      const user = await window.$authservice.checkLogin();
      commit('updateUser', user);
      commit('updateIsAuthenticated', user != null);
      if (user != null) {
        dispatch('getSubscriptions', null, { root: true });
      }
      return user;
    },
    signup() {
      window.$authservice.signup();
    },
    async login({ commit, dispatch }) {
      const user = await window.$authservice.login();

      commit('updateUser', user);
      commit('updateIsAuthenticated', user != null);
      dispatch('getSubscriptions', null, { root: true });

      return user;
    },
    async logout({ commit }) {
      window.$authservice.logout();

      commit('updateUser', null);
      commit('updateIsAuthenticated', false);
    },
  },
};
